import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaListUl } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import CustomInput from "./customInput";
import { safeHtml } from "../../utils/sanitize";

const rowKey = (row) =>
  row?.id ? row.id : row?.name ? row.name : row?.Name ? row.Name : row;

const Sidebar = ({
  data,
  selectedRow,
  setSelectedRow,
  totalProduct,
  title,
  productSearch,
}) => {
  const { t } = useTranslation();
  const [parentId, setParentId] = useState(null);
  const [isOpen, setIsOpen] = useState(false); // mobil çekmece
  const [inData, setInData] = useState(null);
  const [inputVal, setinputVal] = useState("");

  const handleSearch = (e) => {
    const val = e.target.value.toLowerCase();
    setinputVal(val);

    if (productSearch) {
      productSearch(e);
      return;
    }
    const res = data.filter((row) =>
      String(rowKey(row)).toLowerCase().includes(val)
    );
    setInData(res);
  };

  const areEqual = (entity, row) => entity === rowKey(row);

  const checkIfChar = (row) => {
    if (typeof row === "object") {
      return { toChar: "Object" };
    }
    const trimmedItem = row.replace(/^PTR-/g, "");
    const noSpace = trimmedItem.trim();
    const toChar = noSpace.replace(/[^a-zA-Z\sıIğĞüÜşŞiİöÖçÇ]/g, "");
    const isLetter = /[a-zA-Z\sıIğĞüÜşŞiİöÖçÇ]/.test(noSpace.charAt(0));
    const isNumber = /[0-9]/.test(noSpace.charAt(0));
    const theIcon = [...noSpace][0];
    return { toChar, isLetter, theIcon, isNumber };
  };

  const getName = (row) => {
    const name = row.Name ? row.Name : row.name ? row.name : row;
    if (checkIfChar(name).isLetter || checkIfChar(name).isNumber) {
      return "📄";
    }
    return checkIfChar(name).theIcon;
  };

  const checkSideText = (row) => {
    const text = row?.Name ?? row?.name;
    if (typeof text === "string" && text.includes("\n")) {
      return text.split("\n").map((txt, index) => <p key={index}>{txt}</p>);
    }
    if (typeof text === "string") {
      return (
        <p>{text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()}</p>
      );
    }
    return <p>{checkIfChar(row).toChar}</p>;
  };

  useEffect(() => {
    setInData(data);
  }, [data]);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen]);

  if (!inData) return null;

  return (
    <>
      {/* Mobil: listeyi açan yüzen düğme */}
      <button
        type="button"
        className={`950m:hidden fixed bottom-4 left-4 z-30 inline-flex items-center gap-2 rounded-full bg-[--primary] hover:bg-[--primary-hover] text-white px-4 py-3 shadow-lg ${
          isOpen ? "hidden" : ""
        }`}
        onClick={() => setIsOpen(true)}
        aria-expanded={isOpen}
        aria-controls="side-list"
      >
        <FaListUl aria-hidden="true" />
        <span className="text-sm font-medium">{title || t("nav.search")}</span>
      </button>

      {isOpen && (
        <div
          className="950m:hidden fixed inset-0 bg-black/40 z-[45]"
          onClick={() => setIsOpen(false)}
          aria-hidden="true"
        />
      )}

      <div
        id="side-list"
        className={`fixed top-0 bottom-0 left-0 950m:static 950m:bottom-auto w-72 max-w-[85vw] z-50 950m:z-auto bg-[var(--bg-1)] transition-transform duration-200 border-[.5px] border-solid border-[--gr-3] overflow-hidden flex flex-col ${
          isOpen ? "translate-x-0" : "-translate-x-full 950m:translate-x-0"
        }`}
      >
        <div className="bg-[--btn-txt] h-full flex flex-col">
          <div className="border-0 border-b border-[--gr-2] border-solid flex items-center justify-between gap-2 py-3 px-3">
            <h2 className="Poppins font-normal text-base text-[var(--tx-1)] truncate">
              {title}
            </h2>
            <button
              type="button"
              className="950m:hidden text-2xl text-[--gr-6] rounded-full p-1 hover:bg-[--gr-0] bg-transparent flex items-center"
              onClick={() => setIsOpen(false)}
              aria-label={t("common.close")}
            >
              <IoClose aria-hidden="true" />
            </button>
          </div>
          <div className="px-3 pt-2 pb-1">
            <CustomInput
              placeholder={t("nav.search")}
              ariaLabel={t("nav.search")}
              onChange={handleSearch}
              value={inputVal}
            />
          </div>

          <div className="flex-1 overflow-y-auto pb-6 950m:max-h-[calc(100dvh-14rem)]">
            {inData.map((row, index) => {
              const key = rowKey(row);
              const isSelected = areEqual(selectedRow, row);
              const isHover = areEqual(parentId, row);
              const accent =
                isHover || isSelected ? "text-[--primary]" : "text-[#9CA3AF]";
              return (
                <button
                  type="button"
                  key={`${key}-${index}`}
                  className={`w-full text-left min-h-12 flex items-center p-2 pl-5 cursor-pointer text-[var(--tx-1)] bg-transparent border-0 border-l-[3px] border-solid hover:bg-[--gr-10] hover:text-[--primary] ${
                    isSelected
                      ? "bg-[--gr-10] text-[--primary] border-l-[--primary]"
                      : "border-l-transparent"
                  }`}
                  aria-current={isSelected ? "true" : undefined}
                  onClick={() => {
                    setSelectedRow(key);
                    setIsOpen(false);
                  }}
                  onMouseEnter={() => setParentId(key)}
                  onMouseLeave={() => setParentId(null)}
                >
                  {row?.logo ? (
                    <span
                      className={`mr-2 border-[1.5px] border-solid w-8 h-8 flex justify-center items-center rounded-lg shrink-0 ${
                        isHover || isSelected
                          ? "text-[--primary]"
                          : "text-[#E5E7EB]"
                      }`}
                      dangerouslySetInnerHTML={safeHtml(row.logo)}
                    ></span>
                  ) : (
                    <span
                      className={`mr-2 border-[1.5px] border-solid w-8 h-8 flex justify-center items-center rounded-lg shrink-0 ${
                        isHover || isSelected
                          ? "text-[--primary]"
                          : "text-[#E5E7EB]"
                      }`}
                    >
                      <span className={`text-sm ${accent}`}>{getName(row)}</span>
                    </span>
                  )}

                  <span
                    className={`relative flex flex-col justify-center min-w-0 ${
                      row?.id ? "min-h-10" : ""
                    }`}
                  >
                    {checkSideText(row)}
                    {row?.id && (
                      <span className="text-xs absolute -bottom-2 left-0 text-green-500 font-bold">
                        {row.id}
                      </span>
                    )}
                  </span>

                  {row.total && (
                    <span className="flex flex-1 justify-end">
                      <span className="text-[--primary] text-xs w-[3.7rem] text-end">
                        {row.total}
                      </span>
                    </span>
                  )}

                  {totalProduct && (
                    <span className="flex flex-1 justify-end">
                      <span className="text-[--primary] text-xs w-[3.7rem] text-end">
                        {totalProduct[row.Name ? row.Name : row.name ? row.name : row]}
                      </span>
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
